import type { ReactNode } from 'react'
import { useT } from '../i18n'
import { ToastProvider } from '../ui'

/** ToastProvider needs a translated dismiss label, and hooks cannot be called
 *  in the same component that renders the provider they configure — hence
 *  this one-line seam rather than a hardcoded English string. */
export function ToastDismissLabel({ children }: { readonly children: ReactNode }) {
  const t = useT()
  return <ToastProvider dismissLabel={t('common.dismiss')}>{children}</ToastProvider>
}
